export class AppRoles {
  static readonly ADMIN = 'ROLE_ADMIN';
  static readonly RH = 'ROLE_RH';
  static readonly REDACTEUR = 'ROLE_REDACTEUR';
  static readonly TOUT_APTEA = 'ROLE_TOUT_APTEA';
  static readonly CANDIDAT = 'ROLE_CANDIDAT';
}
